const accountRecoveryPasswordMessagesTemplate = `
<ng-messages
    for="getFieldError('password');"
    ng-if="displayFieldMessages('password');"
    multiple
    class="rule-validations"
>
    <ng-message when="required">
        <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordRequired }}</span>
    </ng-message>

    <ng-message when="minLength || maxLength" class="form-validation-rule">
        <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordMinLength }}</span>
    </ng-message>

    <ng-message when="meetCondition0" class="form-validation-rule">
        <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordCondition0 }}</span>
    </ng-message>

    <ng-message when="meetCondition1" class="form-validation-rule">
        <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordCondition1 }}</span>
    </ng-message>

    <ng-message when="meetCondition2" class="form-validation-rule">
        <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordCondition2 }}</span>
    </ng-message>

    <div class="row">
        <div class="col-sm-1">
        </div>

        <div class="col-sm-11">

            <ng-message when="uppercasePattern" class="form-validation-rule">
                <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordUppercasePattern }}</span>
            </ng-message>

            <ng-message when="lowercasePattern" class="form-validation-rule">
                <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordLowercasePattern }}</span>
            </ng-message>

            <ng-message when="numberPattern" class="form-validation-rule">
                <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordNumberPattern }}</span>
            </ng-message>

            <ng-message when="specialCharPattern" class="form-validation-rule">
                <span ng-class="{'text-muted': focusMgr['password']}">{{ ::translatedData.passwordSpecialCharPattern }}</span>
            </ng-message>

        </div>
    </div>

    <ng-message when="compareToUsername" class="form-validation-rule">
        <span ng-class="{'text-muted': focusMgr['password']}">
            {{ ::translatedData.passwordNotMatchUsername }}
        </span>
    </ng-message>
</ng-messages>
`;
export default accountRecoveryPasswordMessagesTemplate;
